<template lang="html">
    <div id="order-detail">
        <van-icon
                @click="goBack"
                class="back-icon"
                size="0.5rem"
                color="#fff"
                name="arrow-left"
        />
        <div class="primary-info">
            <div class="primary-status">
                {{ detail.statusName }}
            </div>
            <van-row class="title">
                {{ detail.endOrganName }}
            </van-row>
            <van-row>
                <van-col span="6">运单号：</van-col>
                {{ detail.trackingNumber }}
                <van-icon
                        v-show="detail.trackingNumber"
                        class="btn-copy"
                        name="description"
                        @click.stop="handleCopyClick(detail.trackingNumber)"
                        size="0.4rem"
                />
            </van-row>
            <van-row>
                <van-col span="6">开单时间：</van-col>
                {{ detail.createDate }}
            </van-row>
            <!--      <van-row>-->
            <!--        <van-col span="6">承运单位：</van-col>-->
            <!--        {{ detail.logisticsCompanyName }}-->
            <!--      </van-row>-->
            <van-row>
                <van-col span="6">运单状态：</van-col>
                {{ detail.statusName }}
            </van-row>
            <van-button
                    @click.stop="
          logisticsSearch(detail.orderNumber || detail.trackingNumber)
        "
                    size="small"
                    type="primary"
            >
                物流跟踪
            </van-button>
        </div>
        <div class="deliver-info">
            <van-cell v-for="item in detail.list" :key="item.id">
                <span slot="icon" class="badge badge-send"></span>
                <div class="title" slot="title">
                    <p>
                        {{ item.consignorName
                        }}<a
                            :href="'tel:' + item.consignorPhone"
                            class="info-concatPhone"
                    >{{ item.consignorPhone }}</a
                    >
                    </p>
                    <p>
                        {{
                        item.consignorProvinceName +
                        item.consignorCityName +
                        item.consignorDistrictName +
                        item.consignorAddress
                        }}
                    </p>
                </div>
                <!--        <span-->
                <!--          slot="right-icon"-->
                <!--          :class="{-->
                <!--            'right-icon': true,-->
                <!--            yitihuo: item.status > 2 && item.status !== 11-->
                <!--          }"-->
                <!--        ></span>-->
            </van-cell>
            <div v-for="orderItem in detail.orderInfoList" :key="orderItem.id">
                <van-row style="font-size:0.375rem;padding-top: 0.25rem;color: #999;"
                >订单号：{{ orderItem.orderNumber }}
                </van-row
                >
                <van-cell v-for="item in orderItem.orderDetailList" :key="item.id">
                    <span slot="icon" class="badge badge-send"></span>
                    <div class="title" slot="title">
                        <p>
                            {{ item.consignorName
                            }}<a
                                :href="'tel:' + item.consignorPhone"
                                class="info-concatPhone"
                        >{{ item.consignorPhone }}</a
                        >
                        </p>
                        <p>
                            {{
                            item.consignorProvinceName +
                            item.consignorCityName +
                            item.consignorDistrictName +
                            item.consignorAddress
                            }}
                        </p>
                    </div>
                    <!--          <span-->
                    <!--            slot="right-icon"-->
                    <!--            :class="{-->
                    <!--              'right-icon': true,-->
                    <!--              yitihuo: item.status > 2 && item.status !== 11-->
                    <!--            }"-->
                    <!--          ></span>-->
                </van-cell>
            </div>
            <van-cell>
                <span slot="icon" class="badge badge-shou"></span>
                <div class="title" slot="title">
                    <p>
                        {{ detail.consigneeName
                        }}<a
                            :href="'tel:' + detail.consigneePhone"
                            class="info-concatPhone"
                    >{{ detail.consigneePhone }}</a
                    >
                    </p>
                    <p>
                        {{
                        detail.consigneeProvinceName +
                        detail.consigneeCityName +
                        detail.consigneeDistrictName +
                        detail.consigneeAddress
                        }}
                    </p>
                </div>
            </van-cell>
        </div>
        <div class="secondary-info">
            <van-collapse v-model="activeName">
                <van-collapse-item class="goods-info" title="货物信息" name="1">
                    <van-row>
                        <van-col span="12"
                        >品名：<span>{{ detail.productName }}</span></van-col
                        >
                        <van-col span="12"
                        >重量：<span>{{ detail.weight }}</span></van-col
                        >
                    </van-row>
                    <van-row>
                        <van-col span="12"
                        >包装：<span>{{ detail.packName }}</span></van-col
                        >
                        <van-col span="12"
                        >体积：<span>{{ detail.volume }}m³</span></van-col
                        >
                    </van-row>
                </van-collapse-item>
                <van-cell style="border-top: 1px dotted #ddd;"
                >服务方式：{{ detail.deliveryName }}
                </van-cell
                >
                <van-collapse-item :title="'付款方式：' + detail.payMeansName" name="2">
                    <!--          <van-row>支付途径：</van-row>-->
                    <!--          <van-row>支付时间：</van-row>-->
                </van-collapse-item>
            </van-collapse>
            <!--      <van-row class="payment" v-if="detail.totalFee !== ''">-->
            <!--        运费：{{ detail.totalFee == "" ? "0.0" : detail.totalFee }}元-->
            <!--        <span v-if="detail.price">已优惠￥{{ detail.price }}</span>-->
            <!--        <van-button type="warning" size="small">对运费有疑问</van-button>-->
            <!--      </van-row>-->
        </div>
        <!-- <div class="btn" v-if="detail.payStatus!==''">
          <van-button v-if="detail.payStatus===1" disbaled>已支付</van-button>
          <van-button v-if="detail.payStatus===0" type="warning" @click="wechatPay">运费支付</van-button>
        </div> -->
    </div>
</template>

<script>
    import {Dialog, Toast} from "vant";

    export default {
        name: "OrderDetail",
        data() {
            return {
                id: this.$route.query.id,
                trackingId: this.$route.query.trackingId,
                detail: {},
                activeName: ["1", "2"]
            };
        },
        created() {
            this.getDetail();
        },
        methods: {
            handleCopyClick(text) {
                this.$copyText(text).then(
                    () => {
                        Toast({
                            message: "已复制！",
                            duration: 1000
                        });
                    },
                    () => {
                        Toast({
                            message: "复制失败！",
                            duration: 1000
                        });
                    }
                );
            },
            // 返回
            goBack() {
                if (this.$route.query.t) {
                    this.$router.push("/order/waybill");
                } else {
                    this.$router.push("/order/myorder");
                }
            },
            // 获取数据
            getDetail() {
                let params = {};
                let url = "";
                if (this.id) {
                    params = {
                        params: this.id
                    };
                    url = "merchant/getOrderInfo";
                } else {
                    params = {
                        params: this.trackingId
                    };
                    url = "merchant/getTrackingInfo";
                }
                this.$axios.post(url, params).then(res => {
                    if (res.data.code === 200) {
                        let data = res.data.data;
                        this.detail = data;
                        // if (data.orderInfoList.length === 0) {
                        //   this.detail.list = [
                        //     {
                        //       consignorName: data.consignorName,
                        //       consignorPhone: data.consignorPhone,
                        //       consignorProvinceName: data.consignorProvinceName,
                        //       consignorCityName: data.consignorCityName,
                        //       consignorDistrictName: data.consignorDistrictName,
                        //       consignorAddress: data.consignorAddress,
                        //       goodsNumber: data.goodsNumber,
                        //       deliveryWeight: data.deliveryWeight,
                        //       status: data.status
                        //     }
                        //   ];
                        // }
                    }
                });
            },
            // 物流跟踪
            logisticsSearch(orderNumber) {
                this.$router.push("/search/logistics/" + orderNumber);
            },
            // 修改
            modify() {
                this.$store.commit({
                    type: "confirmSelect",
                    t: "1",
                    list: []
                });
                this.$store.commit({
                    type: "confirmSelect",
                    t: "2",
                    list: []
                });
                this.$router.push("/order/modify/" + this.id);
            },
            // 取消
            cancelOrder() {
                Dialog.confirm({
                    title: "温馨提示",
                    message: "确定取消该订单？"
                })
                    .then(() => {
                        let params = {
                            params: this.id
                        };
                        this.$axios.post("merchant/cancellation", params).then(res => {
                            if (res.data.code === 200) {
                                this.getDetail();
                            }
                        });
                    })
                    .catch(() => {
                        return false;
                    });
            },
            // 催单
            reminder() {
                Dialog.confirm({
                    title: "温馨提示",
                    message: "是否确认催单？"
                })
                    .then(() => {
                        let params = {
                            params: {
                                consignorAddress: this.detail.consigneeAddress,
                                pullPackWorkerPhone: this.detail.pullPackPhone,
                                workerUserId: this.detail.pullPackWorker
                            }
                        };
                        this.$axios.post("merchant/reminder", params).then(res => {
                            if (res.data.code === 200) {
                                Dialog.alert({
                                    message: "催单成功！"
                                }).then(() => {
                                    this.getDetail();
                                });
                            }
                        });
                    })
                    .catch(() => {
                        return false;
                    });
            },
            // 微信支付
            wechatPay() {
                let params = {
                    params: {
                        trackingId: this.detail.trackingId || this.detail.id
                    }
                };
                this.$axios.post("pay/wechat", params).then(res => {
                    if (res.data.code === 200) {
                        let data = res.data.data;
                        WeixinJSBridge.invoke("getBrandWCPayRequest", {
                            appId: data.appId,
                            timeStamp: data.timeStamp,
                            nonceStr: data.nonceStr,
                            package: data.package,
                            signType: data.signType,
                            paySign: data.paySign
                        }),
                            response => {
                                if (
                                    response.err_msg.toLowerCase() === "get_brand_wcpay_request:ok"
                                ) {
                                    alert("支付成功");
                                } else if (
                                    response.err_msg.toLowerCase() ===
                                    "get_brand_wcpay_request:cancel"
                                ) {
                                    alert("支付取消");
                                } else if (response.err_msg === "get_brand_wcpay_request:fail") {
                                    alert(JSON.stringify(response));
                                }
                            };
                    }
                });
            }
        }
    };
</script>

<style scoped lang="scss">
    .btn-copy {
        -webkit-transform: translateY(2px);
        -moz-transform: translateY(2px);
        -ms-transform: translateY(2px);
        -o-transform: translateY(2px);
        transform: translateY(2px);
        margin-left: 0.1rem;
        color: #0b92e6;
    }

    #order-detail {
        .back-icon {
            position: fixed;
            top: 0;
            left: 0.375rem;
            width: 1rem;
            line-height: 45px;
            z-index: 200;
        }

        .primary-info {
            padding: 0.4rem;
            background-color: #fff;
            position: relative;
            border-bottom: 1px solid #ddd;

            .van-row {
                font-size: 0.4rem;

                > .van-col {
                    color: #999;
                }

                &.title {
                    margin: 0;
                    margin-bottom: 0.25rem;
                    font-size: 0.425rem;
                    font-weight: 600;
                    border-left: 2px solid #0b92e6;
                    padding-left: 0.25rem;
                }
            }

            .primary-status {
                position: absolute;
                right: 0.4rem;
                top: 0;
                padding: 4px 0 12px 5px;
                font-size: 14px;
                color: #fff;
                width: 20px;
                background: url("../../assets/icon_status.png") no-repeat center;
                background-size: cover;
            }

            .van-button {
                position: absolute;
                bottom: 0.4rem;
                right: 0.4rem;
            }
        }

        .deliver-info {
            background-color: #fff;
            padding: 0 0.4rem;

            .van-cell {
                padding: 0.25rem 0;
                border-bottom: 1px solid #ddd;
                display: -webkit-box;
                -webkit-box-align: center;

                .badge {
                    display: block;
                    width: 0.6rem;
                    height: 1rem;
                    background: url("../../assets/order1.png") no-repeat center;
                    background-size: 100%;
                    margin-right: 0.25rem;

                    &.badge-send {
                        background-image: url("../../assets/order2.png");
                    }
                }

                .title {
                    color: #777;
                    padding-right: 1rem;

                    .info-concatPhone {
                        margin-left: 0.25rem;
                        color: #00a5e0;
                    }

                    .send-info {
                        color: red;
                        font-size: 10px;
                        display: flex;
                        justify-content: space-between;
                    }
                }

                .right-icon {
                    display: block;
                    border-left: 1px solid #ddd;
                    width: 1.5rem;
                    height: 1rem;
                    background: url("../../assets/order3.png") no-repeat center right;
                    background-size: 1rem;

                    &.yitihuo {
                        background-image: url("../../assets/icon_yitihuo.png");
                    }
                }

                &.service-mode {
                    border-bottom: 0;

                    .van-col {
                        color: #7c7c7c;
                    }
                }
            }
        }

        .van-collapse {
            background-color: #f5f5f5;
        }

        .secondary-info {
            margin-top: 0.4rem;
            font-size: 0.38rem;

            .van-collapse-item {
                margin-top: 0.25rem;
            }

            .goods-info {
                color: #7c7c7c;

                .van-row {
                    padding: 0.25rem 0;

                    span {
                        color: #000;
                    }
                }
            }

            .payment {
                margin-top: 0.25rem;
                padding: 0.35rem 0;
                text-align: center;
                background-color: #fff;
                position: relative;

                span {
                    color: #999;
                    font-size: 0.3rem;
                    margin-left: 0.25rem;
                }

                .van-button {
                    position: absolute;
                    top: 0;
                    right: 0;
                }
            }
        }

        .btn {
            margin-top: 0.25rem;
            background-color: #fff;
            padding: 0;
            display: flex;

            .van-button {
                flex: 1;
                margin: 0;
                -webkit-transform: translate(0);
                -moz-transform: translate(0);
                -ms-transform: translate(0);
                -o-transform: translate(0);
                transform: translate(0);
            }
        }
    }
</style>
